var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmationModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 60,
    viewBox: "0 0 57 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_154_1185",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 2L35.8185 7.33873L44.8784 7.32201L47.6606 15.9431L55 21.254L52.1843 29.8639L55 38.4739L47.6606 43.7848L44.8784 52.4059L35.8185 52.3891L28.5 57.7279L21.1815 52.3891L12.1216 52.4059L9.33936 43.7848L2 38.4739L4.81565 29.8639L2 21.254L9.33936 15.9431L12.1216 7.32201L21.1815 7.33873L28.5 2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7476 29.8639L25.7135 36.8299L39.6455 22.8979",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_154_1185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.93652 -3.57275H61.9369V63.3007H-4.93652V-3.57275Z",
    fill: "#1D6C76"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationModalIcon);
export default __webpack_public_path__ + "static/media/confirmation-modal-icon.97ae1f58ad700ac4d99da766ed96a445.svg";
export { ForwardRef as ReactComponent };